export default "__VITE_ASSET__B$_25E1v__"